import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import AxiosConfig from '../../../../config/AxiosConfig';
import ActionOnCommandIcon from '../../svg-icons/ActionOnCommandIcon';
import LoadingButton from '../../utils/common/LoadingButton';
import MailIcon from '../../utils/common/MailIcon';
import TaskIcon from '../../utils/common/TaskIcon';
import OrderList from '../drawer/orders/OrderList';
import NewMessage from './ActionPane/Anwsers/NewMessage.jsx';
import OrderActions from './ActionPane/Orders/OrderActions.jsx';
import AddTask from './ActionPane/Tasks/AddTask.jsx';
import ManageTask from './ActionPane/Tasks/ManageTask.jsx';
import Tasks from './ActionPane/Tasks/Tasks.jsx';
import TicketActivity from './DisplayPane/TicketActivity.jsx';
import ProjectTicketDetailsQualification from './ProjectTicketDetailsQualification.jsx';

// function onRenderCallback(
//   id,
//   phase,
//   actualDuration,
//   baseDuration,
//   startTime,
//   commitTime
// ) {
//   console.log('TicketActivity Profiler:', {
//     id, // Identifiant du composant
//     phase, // "mount" ou "update"
//     actualDuration, // Temps de rendu réel
//     baseDuration, // Temps estimé sans optimisations
//     startTime, // Début du rendu
//     commitTime, // Fin du commit
//   });
// }

const ProjectTicketDetails = (props) => {
  const {
    validating,
    tickets,
    _orders,
    ticket,
    tasks,
    mutateTask,
    setOpenNewTicketDialog,
    setNewTicketDialogMessage,
    displayAddNoteDialog,
    handleDisplayAddNoteDialog,
    mutate,
    mutateTicket,
  } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const { taskId } = useParams();
  const profile = useSelector((state) => state?.login?.profile);

  const [leftPanelContent, setLeftPanelContent] = useState(
    location.pathname.includes('order') ? 'order' : 'activities'
  );

  const [rightPanelContent, setRightPanelContent] = useState(
    location.pathname.includes('tasks')
      ? 'tasks'
      : location.pathname.includes('actions')
        ? 'actions'
        : 'response'
  );

  const [displayAddTask, setDisplayAddTask] = useState(false);
  const [ticketStatusToSet, setTicketStatusToSet] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [displayManageTask, setDisplayManageTask] = useState(!!taskId);

  // Met à jour displayManageTask et displayAddTask en fonction de taskId
  useEffect(() => {
    if (taskId) {
      setDisplayManageTask(true);
      setDisplayAddTask(false);
      setRightPanelContent('tasks');
    } else {
      setDisplayManageTask(false);
    }
  }, [taskId]);

  const handleLeftPanelContentChange = (event, newValue) => {
    setLeftPanelContent(newValue);
    navigate(
      `/project/${ticket?.project?._id}/tickets/${ticket?._id}/${newValue}`
    );
  };

  const handleRightPanelContentChange = (event, newValue) => {
    setRightPanelContent(newValue);
    navigate(
      `/project/${ticket?.project?._id}/tickets/${ticket?._id}/${newValue}`
    );
  };

  const handleDisplayAddTask = () => {
    setDisplayAddTask((prev) => {
      if (!prev) {
        setDisplayManageTask(false);
      }
      return !prev;
    });
  };

  const handleProcessTicket = () => {
    setIsLoading(true);
    AxiosConfig.create(
      'put',
      `/tickets/${ticket?._id}/${
        ticketStatusToSet === 'Traité' ? 'setProcessed' : 'setWaiting'
      }`
    )
      .call()
      .exit(() => {
        mutateTicket();
        mutate();
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };

  const handleValidateProcessNo = () => {
    setTicketStatusToSet(null);
  };

  const handleValidateProcessYes = () => {
    handleProcessTicket();
    setTicketStatusToSet(null);
  };

  return (
    <>
      <Dialog open={Boolean(ticketStatusToSet)} maxWidth="sm" fullWidth>
        <DialogTitle>Ticket {ticketStatusToSet}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Voulez-vous passer le statut du ticket à {ticketStatusToSet} ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleValidateProcessNo}>Non</Button>
          <LoadingButton
            isLoading={isLoading}
            onClick={handleValidateProcessYes}
          >
            Oui
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <Box
        sx={{ display: 'flex', justifyContent: 'space-around', flexGrow: 1 }}
      >
        {/* Left panel */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Tabs
            value={leftPanelContent}
            onChange={handleLeftPanelContentChange}
            sx={{ marginLeft: 1 }}
          >
            <Tab
              label={<Typography component={'span'}>Activités</Typography>}
              value="activities"
            />
            <Tab
              label={<Typography component={'span'}>Commande</Typography>}
              value="order"
              disabled={!ticket?.order}
            />
          </Tabs>
          <Tooltip
            placement="right"
            title={
              <Typography component={'span'} style={{ whiteSpace: 'pre-line' }}>
                Toutes les tâches doivent être terminées
              </Typography>
            }
            disableHoverListener={
              !ticket?.hasActiveTask ||
              ticket?.status?.code !== 'WAITING' ||
              ticket?.status?.code === 'NEW'
            }
          >
            <span>
              <Button
                onClick={() => setTicketStatusToSet('En attente')}
                variant="outlined"
                color="primary"
                disabled={
                  ticket?.hasActiveTask ||
                  ticket?.status?.code === 'WAITING' ||
                  ticket?.status?.code === 'NEW'
                }
                sx={{ marginLeft: 1 }}
              >
                En attente
              </Button>
            </span>
          </Tooltip>
          <Tooltip
            placement="right"
            title={
              <Typography component={'span'} style={{ whiteSpace: 'pre-line' }}>
                Toutes les tâches doivent être terminées
              </Typography>
            }
            disableHoverListener={
              !ticket?.hasActiveTask ||
              ticket?.status?.code !== 'PROCESSED' ||
              ticket?.status?.code === 'NEW'
            }
          >
            <span>
              <Button
                onClick={() => setTicketStatusToSet('Traité')}
                variant="outlined"
                color="success"
                disabled={
                  ticket?.hasActiveTask ||
                  ticket?.status?.code === 'PROCESSED' ||
                  ticket?.status?.code === 'NEW'
                }
                sx={{ marginLeft: 1 }}
              >
                Traité
              </Button>
            </span>
          </Tooltip>
          {validating ? (
            <CircularProgress color="info" size={'1em'} />
          ) : (
            <Box sx={{ height: '1em', width: '1em' }} />
          )}
        </Box>

        {/* Right panel */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Tabs
            value={rightPanelContent}
            onChange={handleRightPanelContentChange}
            sx={{ marginLeft: 1 }}
          >
            <Tab
              label={
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <MailIcon boxSize={24} iconSize={16} />
                  <Typography component={'span'}>Répondre</Typography>
                </Box>
              }
              value="response"
            />
            <Tab
              label={
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <ActionOnCommandIcon />
                  <Typography component={'span'}>Actions / commande</Typography>
                </Box>
              }
              value="actions"
            />
            <Tab
              label={
                <Box sx={{ display: 'flex' }}>
                  <TaskIcon boxSize={24} iconSize={16} />
                  <Typography component="span">
                    Tâches (
                    {tasks?.filter((task) => task?.status?.code !== 'DONE')
                      ?.length || 0}
                    )
                  </Typography>
                  <AddBoxOutlinedIcon onClick={handleDisplayAddTask} />
                </Box>
              }
              value="tasks"
            />
          </Tabs>
        </Box>
      </Box>
      <Box sx={{ flexGrow: 1 }}>
        <Grid
          container
          spacing={1}
          justify="space-between"
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'stretch',
          }}
        >
          <Grid size="grow">
            {leftPanelContent === 'activities' && (
              // <Profiler id="TicketActivity" onRender={onRenderCallback}>
              <TicketActivity
                ticket={ticket}
                tickets={tickets}
                setOpenNewTicketDialog={setOpenNewTicketDialog}
                setNewTicketDialogMessage={setNewTicketDialogMessage}
                displayAddNoteDialog={displayAddNoteDialog}
                handleDisplayAddNoteDialog={handleDisplayAddNoteDialog}
                mutate={mutate}
                mutateTicket={mutateTicket}
              />
              // </Profiler>
            )}
            {leftPanelContent === 'order' && (
              <OrderList
                orders={[ticket?.order]}
                // sx={{ width: '43vw', padding: 2 }}
                sx={{
                  height: '73vh', // Tenter de prendre toute la hauteur du parent flex
                  width: '100%',
                  overflow: 'auto',
                  paddingTop: 1,
                  paddingLeft: 1,
                  paddingRight: 0.5,
                }}
              />
            )}
          </Grid>

          <Grid size="grow">
            {!ticket?.isQualified ? (
              <ProjectTicketDetailsQualification
                ticket={ticket}
                mutate={mutate}
                mutateTicket={mutateTicket}
              />
            ) : (
              <>
                {rightPanelContent === 'tasks' && displayAddTask && (
                  <AddTask
                    handleDisplayAddTask={handleDisplayAddTask}
                    ticket={ticket}
                    mutateTicket={mutateTicket}
                    mutateTask={mutateTask}
                  />
                )}
                {rightPanelContent === 'tasks' && displayManageTask && (
                  <ManageTask
                    task={tasks.find((task) => task._id === taskId)}
                    mutateTicket={mutateTicket}
                    mutateTask={mutateTask}
                  />
                )}
                {rightPanelContent === 'response' && (
                  <Box sx={{ height: '100%' }}>
                    {ticket?.contact?.store?.isOpen && (
                      <NewMessage
                        ticket={ticket}
                        mutate={mutate}
                        mutateTicket={mutateTicket}
                        ticketValidating={validating}
                        // sx={{ height: '100%' }}
                      />
                    )}
                  </Box>
                )}
                {rightPanelContent === 'actions' && (
                  <Box sx={{ margin: 1 }}>
                    <OrderActions
                      ticket={ticket}
                      mutateTicket={mutateTicket}
                      profile={profile}
                    />
                  </Box>
                )}
                {rightPanelContent === 'tasks' && !displayAddTask && (
                  <Tasks
                    taskId={taskId}
                    tasks={tasks}
                    mutateTicket={mutateTicket}
                    mutateTask={mutateTask}
                  />
                )}
              </>
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ProjectTicketDetails;
